export enum Themes {
  light = "light",
  pickup = "pickup",
  preferredPickupPartner = "preferredPickupPartner",
}
